import FilterListItem from 'components/List/components/FilterListItem';
import useGA4Tracking from 'modules/tracking/GA4/GA4Tracking';
import { HitCount } from '../shared/styles';
import type { LinkFilterOptionProps } from '../shared/types';

export default function LinkFilterOption({
    model: { displayName, hitCount, isSelected, linkAction },
    menuDisplayName
}: LinkFilterOptionProps) {
    const ga4Tracking = useGA4Tracking();

    const afterSlot = (
        <HitCount forwardedAs="span" size="M">
            ({hitCount})
        </HitCount>
    );

    return (
        <FilterListItem.Anchor
            type="navigation"
            anchorProps={{
                action: linkAction
            }}
            selected={isSelected}
            AfterRenderer={() => afterSlot}
            onClick={() =>
                ga4Tracking({
                    eventName: 'link_click',
                    category: 'navigation',
                    eventParams: [
                        { param_name: 'link_type', param_value: 'internal' },
                        { param_name: 'list_name', param_value: displayName },
                        { param_name: 'filter_list_name', param_value: menuDisplayName }
                    ]
                })
            }
        >
            {displayName}
        </FilterListItem.Anchor>
    );
}
